import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-download\"><path fill=\"#da1831\" d=\"M24 22.125H0V24h24zm-6.117-10.396l-4.945 4.945V0h-1.875v16.674L6.117 11.73l-1.326 1.326L12 20.263l7.209-7.208z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol